import  {ItemGroupQuery} from 'web-shared';
import {Type} from 'class-transformer';
import {PropertyMappingQuery} from 'web-shared';
import {IdCodeNameQuery} from 'common-shared';

export class ManufacturedItemGroupQuery extends ItemGroupQuery {
  @Type(() => PropertyMappingQuery)
  ProcedureItemProperties: PropertyMappingQuery[];

  static Columns() {
    return [...IdCodeNameQuery.Columns(), 'TypeClv', 'Comment'];
  }
}
